<!-- Grilla de anuncios reutilizable: 1 columna en mobile, 2 en desktop -->
<div
	*ngIf="announcements?.length"
	class="grid grid-cols-1 lg:grid-cols-2 xxl:grid-cols-3 gap-8 lg:gap-x-6 lg:gap-y-12 justify-items-center lg:justify-items-stretch"
>
	<app-card-anuncios
		*ngFor="let item of announcements; let i = index"
		class="w-full"
		[cardMediaUrl]="mediaBaseUrl + item.imagen"
		[mediaType]="mediaType(item)"
		[smScrollIsActive]="true"
		[cardChipLeftIsActive]="false"
		[coinCustomImage]="coinCustomImage"
		(multimediaClick)="onMediaClick(item, i)"
	>
		<ng-container cardDescription>
			<div class="flex items-center box-content division-line border-b-1 border-solid pt-3 pb-2 lg:min-h-[36px]">
				<div class="w-full anuncio-titulo text-xl md:text-lg text-default_text font-bold leading-6">{{ item.nombre }}</div>
			</div>
			<div class="text-default_text text-base overflow-hidden pt-2 pb-3 lg:flex lg:items-center">
				<div class="h-full overflow-y-auto lg:h-auto lg:max-h-full w-full">
					<span [outerHTML]="item.contenido"></span>
				</div>
			</div>
			<!-- acciones -->
			<div class="flex items-center gap-4 w-full text-base text-white font-medium justify-center pb-4">
				<button
					*ngIf="item.destino"
					class="flex items-center justify-center bg-primary hover:bg-primary_focused rounded-lg py-2.5 px-6 xl:px-5 xl:py-2 xxl:px-6 xxl:py-2.5 lg:min-w-[100px]"
					(click)="goToDestino(item)"
				>
					<span class="mr-[14px]" [ngClass]="{ 'hidden lg:flex': item.destino && item.link && item.archivo }">{{ 'ANUNCIOS.IR' | translate }}</span>
					<mat-icon class="mdi mdi-chevron-right text-base leading-6 lg:leading-4 lg:mt-[2px]"></mat-icon>
				</button>

				<button
					*ngIf="item.link"
					class="flex items-center justify-center bg-primary hover:bg-primary_focused rounded-lg py-2.5 px-6 xl:px-5 xl:py-2 xxl:px-6 xxl:py-2.5"
					(click)="openLink(item.link)"
				>
					<span class="mr-4" [ngClass]="{ 'hidden lg:flex': item.destino && item.link && item.archivo }">{{ 'ANUNCIOS.LINK' | translate }}</span>
					<mat-icon class="mdi mdi-open-in-new text-base"></mat-icon>
				</button>

				<button
					*ngIf="item.archivo"
					class="flex items-center justify-center bg-primary hover:bg-primary_focused rounded-lg py-2.5 px-6 xl:px-5 xl:py-2 xxl:px-6 xxl:py-2.5"
					(click)="confirmDownload(item.archivo)"
				>
					<span class="mr-4" [ngClass]="{ 'hidden lg:flex': item.destino && item.link && item.archivo }">{{ 'ANUNCIOS.ABRIR' | translate }}</span>
					<mat-icon class="mdi mdi-file-pdf-box text-base"></mat-icon>
				</button>
			</div>
		</ng-container>

		<ng-container audioPlayer>
			<ng-container *ngIf="item.media?.media_type === 'audio'">
				<ion-icon *ngIf="cardSelectedIndex !== i" name="caret-forward-circle" class="center-element-translate play-video-icon text-[82px] text-primary z-2 rounded-full"></ion-icon>
				<div *ngIf="audioPlayerIsActive && cardSelectedIndex !== null && cardSelectedIndex === i" [id]="'grid-audio-container-' + i" class="center-transform absolute z-5 w-fit"></div>
			</ng-container>
		</ng-container>
	</app-card-anuncios>
</div>

<!-- zoom de imagen -->
<div class="zoom-actived" *ngIf="zoom" (click)="zoomImage()">
	<img [src]="mediaBaseUrl + focusImageValue" class="image-zoom py-4" />
	<div class="h-12 w-12 flex justify-center items-center absolute bg-gray-100 bg-opacity-50 rounded-default ion-activatable ripple-parent cursor-pointer" style="top: 10px; right: 10px">
		<ion-ripple-effect class="rounded-full"></ion-ripple-effect>
		<ion-icon name="close" class="text-2xl"></ion-icon>
	</div>
</div>

<!-- reproductor de video -->
<ion-modal [isOpen]="isVideoPlayerOpen" backdropDismiss="true" cssClass="modal-video-player" (didDismiss)="closeVideoPlayer()">
	<ng-template>
		<app-video-player
			*ngIf="focusMediaValue?.media?.media_type === 'video'"
			(closePlayerClick)="closeVideoPlayer()"
			[setAutoPlay]="false"
			typeMedia="video"
			[videoUrl]="mediaBaseUrl + focusMediaValue.media?.value"
			[posterImg]="mediaBaseUrl + focusMediaValue.imagen"
			[videoTitle]="focusMediaValue.nombre"
			class="w-full h-full"
		/>

		<app-video-player
			*ngIf="focusMediaValue?.media?.media_type === 'youtube'"
			(closePlayerClick)="closeVideoPlayer()"
			typeMedia="youtube"
			[videoUrl]="focusMediaValue.media?.value"
			class="w-full h-full"
		/>

		<app-video-player
			*ngIf="focusMediaValue?.media?.media_type === 'vimeo'"
			(closePlayerClick)="closeVideoPlayer()"
			typeMedia="vimeo"
			[videoUrl]="focusMediaValue.media?.value"
			[videoTitle]="focusMediaValue.nombre"
			class="w-full h-full"
		/>
	</ng-template>
</ion-modal>
